﻿import mitt, { Emitter } from 'mitt';

export type Source = 'frontend' | 'configurator';

export type AppEvents = {
    "html_ready": { root: HTMLElement }
};

export class EventBus {
    private emitter: Emitter<AppEvents>;

    constructor() {
        this.emitter = mitt<AppEvents>();
    }

    on<E extends keyof AppEvents>(event: E, callback: (payload: AppEvents[E]) => void) {
        this.emitter.on(event, callback);
    }

    off<E extends keyof AppEvents>(event: E, callback?: (payload: AppEvents[E]) => void) {
        this.emitter.off(event, callback);
    }

    emit<E extends keyof AppEvents>(event: E, payload: AppEvents[E]) {
        this.emitter.emit(event, payload);
    }

}